import { useNavigate } from "react-router-dom";
import { UserRound, LogIn, UserPlus, ClipboardList, Wrench, ShoppingBag, LayoutDashboard } from "lucide-react";
import { Button } from "./ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { useAuth } from "../context/AuthContext";
import { homeFor } from "./ProtectedRoute";
import { B2B_REG } from "./BlurredPrice";

export default function AreaClientiMenu({ mobile = false, onNavigate }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const label = !user ? "Area clienti" : user.role === "b2b" ? "Listino B2B" : "La mia area";
  const go = (to) => { onNavigate?.(); navigate(to); };
  const items = user
    ? [{ to: homeFor(user.role), label: "La mia area", icon: LayoutDashboard }, { to: "/comodato", label: "Comodato impianti", icon: Wrench }, { to: "/negozio", label: "Shop", icon: ShoppingBag }]
    : [{ to: "/accedi", label: "Accedi", icon: LogIn }, { to: B2B_REG, label: "Registrati come operatore", icon: UserPlus }, { to: "/listino", label: "Listino operatori", icon: ClipboardList }, { to: "/comodato", label: "Comodato impianti", icon: Wrench }];
  if (mobile) {
    return (
      <div className="pt-2 border-t border-stone-200 space-y-1" data-testid="nav-mobile-area-menu">
        <p className="text-xs uppercase tracking-wider text-stone-400 pt-2">Area clienti</p>
        {items.map((i) => <button key={i.to} type="button" onClick={() => go(i.to)} className="flex items-center gap-2 w-full text-left text-base font-medium text-stone-700 hover:text-[#0F4C81] py-1" data-testid={`nav-mobile-area-${i.label.toLowerCase().replace(/\s+/g, "-")}`}><i.icon className="w-4 h-4" />{i.label}</button>)}
      </div>
    );
  }
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button data-testid="nav-agent-area-btn" onClick={(e) => e.stopPropagation()} className="bg-[#0F4C81] hover:bg-[#0A365C] text-white rounded-full px-5"><UserRound className="w-4 h-4 mr-2" />{label}</Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60 rounded-xl" data-testid="nav-area-menu">
        <DropdownMenuLabel className="text-xs uppercase tracking-wider text-stone-400">Bar, lidi e ristoranti</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {items.map((i) => <DropdownMenuItem key={i.to} onSelect={() => go(i.to)} className="cursor-pointer gap-2 py-2.5" data-testid={`nav-area-${i.label.toLowerCase().replace(/\s+/g, "-")}`}><i.icon className="w-4 h-4 text-[#0F4C81]" />{i.label}</DropdownMenuItem>)}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
